import type { ReactElement } from 'react';

import { PaymentButton } from '@/modules/perseo-billing/components';
import { PAYMENT_METHODS } from '@/modules/perseo-billing/constants/src/providers/payment-methods';
import { useGetCartTotals } from '@/modules/perseo-billing/hooks';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

type TTotalPayment = {
  label: string;
  price: string;
  cardIcon: ReactElement;
};

export const CencoPayFooter = () => {
  const { otherMethods, cencoPay, cencosudCard } = useGetCartTotals();

  if (cencoPay?.price && cencosudCard?.price) {
    return (
      <div className="co-hidden lg:co-flex co-justify-between co-items-center co-pt-16px">
        <div className="co-flex co-flex-1 co-items-center co-gap-[24px] co-px-[8px] co-py-[16px] co-justify-between">
          <div className="co-flex co-w-full co-justify-between co-flex-col">
            <Typography weight="semibold" color="pds-neutral-900">
              Totales con CencoPay:
            </Typography>

            <TotalPayment
              label={'Tarjeta Cencosud:'}
              price={cencosudCard?.price}
              cardIcon={
                <>
                  <Icon width={24} height={24} icon="CencoCreditCardIcon" />
                  <Icon width={24} height={24} icon="CencoPayIcon" />
                </>
              }
            />
            <TotalPayment
              label={'Otras tarjetas:'}
              price={otherMethods?.price}
              cardIcon={<Icon width={24} height={24} icon="CencoPayIcon" />}
            />
          </div>

          <div className="co-w-full co-h-48px co-flex">
            <PaymentButton
              method={PAYMENT_METHODS.CENCOPAY}
              label={'Continuar con CencoPay'}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="co-hidden lg:co-flex co-justify-between co-items-center co-pt-16px">
      <div className="co-flex co-flex-1 co-items-center co-gap-[24px] co-px-[8px] co-py-[16px] co-justify-between">
        <div className="co-flex co-w-full co-justify-between co-flex-col">
          <TotalPayment
            label={'Total con CencoPay:'}
            price={otherMethods?.price}
            cardIcon={<Icon width={24} height={24} icon="CencoPayIcon" />}
          />
        </div>

        <div className="co-w-full co-h-48px co-flex co-items-center">
          <PaymentButton
            method={PAYMENT_METHODS.CENCOPAY}
            label={'Continuar con CencoPay'}
          />
        </div>
      </div>
    </div>
  );
};

const TotalPayment = ({ label, price, cardIcon }: TTotalPayment) => {
  return (
    <span className="co-w-full co-flex co-font-montserrat co-font-medium co-text-common-grey co-items-center co-gap-16px co-justify-between">
      <span className="co-font-medium">{label}</span>{' '}
      <div className="co-flex co-gap-8px co-items-center">
        {cardIcon}
        <span className="co-font-bold co-text-[#1A1A1A]">{price}</span>
      </div>
    </span>
  );
};
